'use client'

import React from 'react'
import { NextPage } from 'next'
import { isDev } from 'app/general'
import MuiAlert from '@mui/material/Alert';
import { useEffect, useState } from 'react'
import styles from 'styles/Alert.module.scss'
import { joinClassnames } from 'helpers/classNames'
import { removeAlert } from 'actions/alert'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'

interface Props { }
const AlertManager: NextPage<Props> = (props: Props) => {
  const alert = useAppSelector((state) => state.alertReducer.alert)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (alert) {
      setTimeout(() => {
        dispatch(removeAlert())
      }, 5000)
    }
  }, [alert])

  return (
    <>{alert && <Alert severity={alert.severity}>{alert.message}</Alert>}</>
  )
}

export default AlertManager

const Alert = (props: any) => {
  const [fadeClass, setFadeClass] = useState<any>(null)
  const [showClass, setShowClass] = useState<any>(null)
  const className = joinClassnames([styles.container, showClass, fadeClass])
  const [showAlert, setShowAlert] = useState<boolean>(true)

  useEffect(() => {
    setTimeout(() => {
      setShowClass(styles.show)
      setTimeout(() => {
        setFadeClass(styles.fade)
        setTimeout(() => {
          setShowAlert(false)
        }, 500)
      }, 4000)
    }, 50)
  }, [])

  if (!showAlert) return <></>
  return (
    <div className={className}>
      <MuiAlert onClose={() => { setFadeClass(styles.fade) }} elevation={6} variant="filled" {...props} />
    </div>
  )
}
